import "./ConstructionProcess.css";

import processData from "../../data/processData";
import ProcessStep from "./ProcessStep";

const ConstructionProcess = () => {
  return (
    <section className="construction1-process">
      <div className="process-container1">
        <div className="section-heading1">
          <span className="section-tag1">OUR PROCESS</span>

          <h2>From Vision to Victory</h2>

          <p>
            We follow a systematic construction process to deliver world-class
            sports infrastructure with exceptional quality, durability and
            precision.
          </p>
        </div>

        <div className="process-grid">
          {processData.map((process) => (
            <ProcessStep key={process.id} process={process} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConstructionProcess;
